export default "__VITE_ASSET__VnSb5FvV__"